// extracted by mini-css-extract-plugin
export var bodySections = "_c5-8";
export var gray = "_c5-7";
export var green = "_c5-4";
export var iconContainer = "_c5-9";
export var iconWidgetContainer = "_c5-1";
export var phoneIcon = "_c5-2";
export var red = "_c5-5";
export var statusDot = "_c5-3";
export var widgetContainer = "_c5-0";
export var yellow = "_c5-6";